import React from 'react';
import Cta from '../components/Cta';
import Footer from '../components/Footer';
import Accueil from '../components/Accueil';
import Intro from '../components/Intro';
import Portfolio from '../components/Portfolio';
import Services from '../components/Services';
import ScrollToTop from '../components/ScrollToTop';


const Home = () => {
    return (
        <>
        <ScrollToTop>
            <Cta/>
            <Accueil />
            <Intro />
            <Services />
            <Portfolio />
            <Footer />
            </ScrollToTop>
        </>

    )
}

export default Home;

